/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2025-08-04 16:25:50
 * @LastEditors: taoyuan taoyuan@originqc.com
 * @LastEditTime: 2025-09-12 14:06:07
 * @FilePath: \qmall\qcloud-mall-pc\src\views\personal-center\components\activation-info\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import './index.scss';

import copyBtn from '../../assets/copy_btn.svg';
import CodeModal from '../code-modal';
import FreeModal from '../free-modal';
import { useState } from 'react';
import { getActivation } from '@/api/personal-center';
import { EyeInvisibleOutlined } from '@ant-design/icons';
import copy from 'copy-to-clipboard';
import { message, Tooltip } from 'antd';

interface IActivationInfo {
  info: any;
  searchOrder: () => void;
}

const ActivationInfo: React.FC<IActivationInfo> = ({ info, searchOrder }) => {
  const { activation } = info; //激活信息
  const proInfo = info.productList?.[0] ?? {}; //产品信息
  const modelsInfo = proInfo?.models?.[0] ?? {};
  const subscribe = proInfo?.models?.[0].subscribe?.[0] ?? {};
  const [modalInfo, setModalInfo] = useState({ info: {}, visible: false });
  const [showCode, setShowCode] = useState(false);
  const [code, setCode] = useState('');
  const [showFreeModal, setShowFreeModal] = useState(false);

  const getActiveCode = async (params: any) => {
    const res: any = await getActivation({ ...params, orderId: info.id });
    if (res.success) {
      setShowCode(true);
      setCode(res.obj.code);
      searchOrder();
      setModalInfo({ info: {}, visible: false });
    } else {
      message.error(res?.message ?? '查看激活码失败');
    }
  };

  const copyCode = () => {
    if (copy(code, { format: 'text/plain' })) {
      message.destroy();
      message.success('复制成功');
    }
  };

  const downSDK = () => {
    window.location.href = activation?.packageAddr;
    // if (subscribe.unit !== '0') {
    //   window.location.href = activation?.chargePackage;
    //   return;
    // }
    // setShowFreeModal(true);
  };

  return (
    <div className='activation-info-container'>
      <h4 className='aic-title'>商品激活状态</h4>
      <div className='content-row'>
        <div className='content-item'>
          <label>使用方式：</label>
          <span>
            <a className='sdk' onClick={() => downSDK()}>
              下载SDK
            </a>
            <a target='_blank' href={activation?.docUrl} className='guide'>
            开发手册
            </a>
          </span>
        </div>
        <div className='content-item'>
          <label>激活状态：</label>
          {activation?.status === 1 ? (
            <span className='status-active'>已激活</span>
          ) : (
            <span className='status-un'>未激活</span>
          )}
        </div>
        {subscribe.unit !== '0' && (
          <div className='content-item'>
            <label className='machine-item'>已激活设备数：</label>
            <span>
              {activation?.machineCount}/{activation?.maxMachineCount}
            </span>
          </div>
        )}
      </div>
      {/* 永久授权 */}
      {subscribe.unit !== '0' && (
        <>
          <div className='content-row'>
            <div className='content-item'>
              <label>激活码：</label>
              <span>
                {showCode ? (
                  <>
                    <Tooltip placement='topLeft' title={code}>
                      <span className='code-con'>{code}</span>
                    </Tooltip>
                    <img
                      className='copy-btn'
                      onClick={copyCode}
                      src={copyBtn}
                      alt=''
                    />
                    <EyeInvisibleOutlined
                      onClick={() => setShowCode(false)}
                      className='eye-btn'
                    />
                  </>
                ) : (
                  <>
                    **************
                    <a
                      onClick={() =>
                        setModalInfo({ ...modalInfo, visible: true })
                      }
                      className='code'
                    >
                      查看激活码
                    </a>
                  </>
                )}
              </span>
            </div>
            <div className='content-item'>
              <label>订阅周期：</label>
              <span>{activation?.validityName}</span>
            </div>
          </div>
          <div className='content-row'>
            <div className='content-item'>
              <label>激活时间：</label>
              <span>{activation?.startTime ?? '-'}</span>
            </div>
            <div className='content-item'>
              <label>失效时间：</label>
              <span>{activation?.endTime ?? '-'}</span>
            </div>
          </div>
        </>
      )}
      <CodeModal
        info={modalInfo.info}
        visible={modalInfo.visible}
        setModalInfo={setModalInfo}
        getActiveCode={getActiveCode}
      />
      <FreeModal
        freeVisible={showFreeModal}
        setFreeVisible={(visible) => setShowFreeModal(visible)}
        sdkLink={activation?.freePackage}
      />
    </div>
  );
};

export default ActivationInfo;
